import type { StnStatus } from '@api/warehouse-ops';

/** Display names for STN statuses — the badge and the Status filter read the same map. */
/**
 * A partnered-carrier shipment (Amazon's ATS) is held at Approved until its booked pickup day,
 * even though Amazon already calls it IN_TRANSIT: the units are still on the seller's dock. Say so
 * instead of "Approved", which is what a note raised here would mean. Null = use the status label.
 */
export const mirroredStatusLabel = (stn: {
    status: StnStatus;
    externalStatus?: string | null;
    transportMode?: string | null;
}): string | null =>
    stn.status === 'APPROVED' &&
    stn.transportMode === 'AMAZON_PARTNERED_CARRIER' &&
    !!stn.externalStatus &&
    !['WORKING', 'READY_TO_SHIP'].includes(stn.externalStatus)
        ? 'Pickup booked'
        : null;

export const STATUS_LABEL: Record<StnStatus, string> = {
    DRAFT: 'Draft',
    APPROVED: 'Approved',
    DISPATCHED: 'Dispatched',
    IN_TRANSIT: 'In Transit',
    RECEIVED: 'Received',
    CANCELLED: 'Cancelled',
};

/**
 * Where an STN came from: raised here (PLATFORM) or mirrored from an outside system. Only
 * platform-raised STNs carry actions (push, dispatch, receive).
 */
export const SOURCE_LABEL: Record<string, string> = {
    PLATFORM: 'Platform',
    UNICOMMERCE_GATEPASS: 'Unicommerce gate pass',
    AMAZON_SP_API: 'Amazon FBA',
    EXTERNAL: 'External',
};

/** The statuses the By SKU sheet counts: the note is raised and the stock has not landed. */
export const OPEN_STN_STATUSES: StnStatus[] = ['APPROVED', 'DISPATCHED', 'IN_TRANSIT'];
